import {Space} from "antd";
import {OfferingFormAccordionItem} from "../accordion/accordion-item";
import {ServiceGenInfoFormFields} from "../services/gen-info";
import {SubSettingsFormFields} from "../general/settings/sub-settings";
import {SubscriptionTierFormFields} from "./subscription-tier-form";

export type CreateSubscriptionOfferingFormProps = {
  isGeneralInformationError?: boolean;
  isTiersError?: boolean;
  isSettingsError?: boolean;
  /** When true, hides the tier section (e.g. flows where tiers are not on this form). */
  hideTierSection?: boolean;
};

export function CreateSubscriptionOfferingForm({
  isGeneralInformationError,
  isTiersError,
  isSettingsError,
  hideTierSection,
}: CreateSubscriptionOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <OfferingFormAccordionItem
        index={0}
        title="General Information"
        isError={!!isGeneralInformationError}
      >
        <ServiceGenInfoFormFields
          nameFieldId="subscriptionName"
          nameFieldLabel="Subscription name"
          nameFieldPlaceholder="e.g. Creators hub"
          descriptionFieldId="subscriptionDescription"
          descriptionFieldLabel="Description"
          descriptionFieldPlaceholder="What is your subscription about?"
        />
      </OfferingFormAccordionItem>
      {!hideTierSection ? (
        <OfferingFormAccordionItem
          index={1}
          title="Subscription tier"
          isError={!!isTiersError}
        >
          <SubscriptionTierFormFields />
        </OfferingFormAccordionItem>
      ) : null}
      <OfferingFormAccordionItem
        index={hideTierSection ? 1 : 2}
        title="Settings"
        isError={!!isSettingsError}
      >
        {/*
          Purchase limit checkbox omitted — not sent on subscription create/update API.
          (Was purchaseLimitLabel="Set the number of units a customer can purchase in a single transaction")
        */}
        <SubSettingsFormFields
          hideFromProfileLabel="Hide from your profile page"
          requestCustomerPhoneNumberLabel="Request customer's phone number"
          showUrlRedirect={false}
        />
      </OfferingFormAccordionItem>
    </Space>
  );
}
